<template>
  <div class="box">
    <a v-on:click="collapsed = !collapsed" class="titleExamen">
      <i :class="[collapsed ? 'fa-plus' : 'fa-minus active', 'fa']"></i>
      {{ title }}
    </a>
    <b-row v-if="!collapsed">
      <b-col class="text mt-3">
        <VueMarkdown>{{ text }}</VueMarkdown>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";

export default {
  data() {
    return {
      collapsed: true,
    };
  },
  props: ["id", "title", "text"],
  components: {
    VueMarkdown,
  },
};
</script>

<style lang="stylus">
@import '../css/palette.styl';

.text {
  line-height: 1.75rem
  }

.text h2, .text h3, .text h4 {
  padding-bottom: 10px;
  padding-top: 20px;
  font-size: 1.25rem;
  font-weight: bold;
  }

.text img {
  max-width: 400px;
  max-height: 500px;
}

.box {
  border-bottom: 2px solid $accentColor;
  padding-bottom: 30px;
  padding-top: 30px;
}

.titleExamen {
  font-size: 1.4rem;
  cursor: pointer;
  margin-bottom: 20px;
  font-weight: 500;
}

.titleExamen  i {
  margin-right: 20px;
  color: $pastelGreenColor;
}

i.active {
  color: $accentColor;
}

.nav-pills .nav-link {
  color: black;
  cursor: pointer;
}

.nav-pills .nav-link:hover {
  background-color: $accentColor !important;
}

.nav-pills .nav-link.active {
  background-color: $accentColor !important;
}
</style>
